module.exports = __webpack_public_path__ + "../resources/img/bg_error01.10f47a27.png";